import { boxPlanningKeys } from "@/modules/boxPlanning/gateway/boxPlanningKeys"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export function useBoxPlanningSlots(startDate: Date | undefined, endDate: Date | undefined, programId?: string) {
  const { boxPlanningApi } = useServicesContext()

  return useSuspenseQuery({
    queryKey: boxPlanningKeys.slots({ startDate, endDate, programId }),
    queryFn: async () => {
      return await boxPlanningApi.getSlots(startDate, endDate, programId)
    },
  })
}
